<template>
  <modal ref="modal" contentClasses="px-5 py-4">
    <template v-slot:header>
      <p class="font-weight-semibold text-center">Completa</p>
    </template>
    <p class="text-center">
      Se l’installazione è avvenuta con successo puoi completare il contatto. Il
      contatto passerà allo stato COMPLETATO.
    </p>
    <p>
      Note:
      <textarea
        placeholder="Inserisci eventuali note di installazione"
        class="form-control"
        style="resize: none"
        v-model="installationNotes"
      ></textarea>
    </p>
    <template v-slot:footer>
      <div class="row w-100">
        <div class="col-6 pl-0">
          <button
            type="button"
            class="btn btn-outline-primary w-100"
            @click.prevent="onCanceled"
          >
            Annulla
          </button>
        </div>
        <div class="col-6 pr-0">
          <button
            type="submit"
            class="btn btn-primary w-100"
            @click.prevent="onConfirmed"
          >
            Conferma
          </button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script lang="ts">
import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import Modal from "components/Modal.vue";

@Component({ components: { Modal } })
export default class PlaceCompleteModal extends Vue {
  @Ref() readonly modal!: Modal;

  private installationNotes: string | null = null;

  show() {
    this.modal.show();
  }

  hide() {
    this.modal.hide();
  }

  onCanceled() {
    this.hide();
    this.$emit("canceled");
  }

  onConfirmed() {
    this.hide();
    this.$emit("confirmed", this.installationNotes);
  }
}
</script>
